// Screens that moved keep their old address working (bookmarks, old help links, a link in a text):
// Customer Orders became Orders (Mark, 2026-10-23), /warehouse/customer-orders/** is
// /warehouse/orders/**, its query (?settings=open&tab=...) and hash kept.
// Named 00. so it runs before the other global middleware (Nuxt runs them in name order).
const MOVED: ReadonlyArray<readonly [string, string]> = [
  ['/warehouse/customer-orders', '/warehouse/orders'],
]

export default defineNuxtRouteMiddleware((to) => {
  for (const [from, into] of MOVED) {
    if (to.path === from || to.path.startsWith(`${from}/`)) {
      return navigateTo({ path: into + to.path.slice(from.length), query: to.query, hash: to.hash }, { replace: true, redirectCode: 301 })
    }
  }
})
